import onSearchTextChangedInternal from '../actions/onSearchTextChangedInternal';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';

mutator(onSearchTextChangedInternal, actionMessage => {
    const { searchText, showSuggestionsUi } = actionMessage;
    const store = getScenarioStore(actionMessage.scenarioId);

    store.searchText = searchText;
    store.searchTextForSuggestion = searchText;
    store.isSuggestionsDropdownVisible = showSuggestionsUi;
});
